// @flow
import * as React from "react";
import styled from "styled-components";

import Gettext from "../common/Gettext";
import Header from "./Header";
import Button from "../Button";
import { fontSize } from "../common/styled-mixins";

const Wrapper = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  display: flex;
  flex-direction: column;
  width: calc(100% - 20px);
  height: 190px;
  background-color: #fff;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  z-index: 100;

  @media (min-width: 568px) {
    max-width: 395px;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-content: space-between;
  flex-grow: 1;
  flex-shrink: 1;
  width: 100%;
  padding: 1.5em;
  font-size: ${fontSize(16)};
  line-height: 1.5;
  color: #414141;

  @media (max-width: 479px) {
    font-size: ${fontSize(14)};
  }
`;

const Content = styled.div`
  flex-grow: 1;
  flex-shrink: 0;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  width: 100%;
`;

const CancelButton = styled.span`
  color: #a7a7a7;
  text-decoration: underline;
  cursor: pointer;
`;

const AllowButton = styled(Button)`
  width: auto;
  min-width: 8.75em;
  margin-left: auto;
`;

type Props = {
  onAccept: () => void,
  onDismiss: () => void
};

function OneSignalPopup(props: Props) {
  return (
    <Wrapper>
      <Header />
      <Container>
        <Content>
          <Gettext>
            We'd like to show you notifications for the latest news and updates.
          </Gettext>
        </Content>
        <Buttons>
          <CancelButton onClick={props.onDismiss}>
            <Gettext>NO THANKS</Gettext>
          </CancelButton>
          <AllowButton color="green" onClick={props.onAccept}>
            <Gettext>ALLOW</Gettext>
          </AllowButton>
        </Buttons>
      </Container>
    </Wrapper>
  );
}

export default OneSignalPopup;



// WEBPACK FOOTER //
// ./src/components/OneSignal/Popup.js